import { render } from "./CommissionHelp.vue?vue&type=template&id=54c69860&scoped=true"
const script = {}

import "./CommissionHelp.vue?vue&type=style&index=0&id=54c69860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c69860"]])

export default __exports__